module.exports = __webpack_public_path__ + "78ae4468b26ed83b4596842686e8e662.png";